import React from 'react';
import FreeHypothesisDisplay from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/components/informationDisplay/FreeHypothesisDisplay';
import { FreeHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/types';
import Flex from 'ui/Flex/Flex';

const FreeHypotheses = ({
    freeHypotheses,
}: {
    freeHypotheses: FreeHypothesis[];
}) => (
    <Flex display="flex" flexDirection="column" alignItems="flex-start">
        {freeHypotheses.map((hypothesis) => (
            <FreeHypothesisDisplay
                key={hypothesis.id}
                hypothesis={hypothesis}
            />
        ))}
    </Flex>
);

export default FreeHypotheses;
